import {
    DISPLAY_OVERLAY,
    SCREEN_WIDTH,
    HEADER_NAVIGATION,
    SET_MOBILE_MENU_STATE,
    WINDOW_SCROLL,
    MOBILE_OVERLAY_SHOW_HIDE,
    SET_NOTIFICATION,
    SET_MYACCOUNTINFO
} from "../constant";

export function menuOverlay (flag) {
    return{
        type:DISPLAY_OVERLAY,
        payload:flag
    }
}

/* export function removeMenuOverLay () {
    return{
        type:HIDE_OVERLAY
    }
} */

export function setScreenWidth(width){
    //debugger;
    return{
        type:SCREEN_WIDTH,
        payload:width
    }
}

export function headerNavigation(navData){
    return{
        type:HEADER_NAVIGATION,
        payload: navData
    }
}
export function setNotification(notificationData){
    return{
        type:SET_NOTIFICATION,
        payload: notificationData
    }
}

export function setMobileMenuState(mobileMenuState){
    return{
        type:SET_MOBILE_MENU_STATE,
        payload:mobileMenuState
    }
}
export function setWindowScroll(flag){
    return{
        type:WINDOW_SCROLL,
        payload:flag
    }
}
export function setMobileOverlayDisplay(display){
    return{
        type:MOBILE_OVERLAY_SHOW_HIDE,
        payload:display   
    }
}
export function setMyAccountInfo(data){
    return{
        type:SET_MYACCOUNTINFO,
        payload:data   
    }
}

